import $ from 'cash-dom';

export default () => {
  const $linksOpen = $('.js-open-popup');
  const $sections = $('.js-popup-content'); // to show

  if ($linksOpen.length) {
    // open
    $linksOpen.on('click', (e1) => {
      e1.preventDefault();

      const $this = $(e1.currentTarget);
      const $section = $(`#${$this.data('section')}`);
      const $close = $section.find('.js-close-popup');
      const $wrap1 = $section.parents('.js-popup-wrap'); // parent
      const $wrap2 = $this.parents('.js-popup-wrap'); // parent

      $sections.removeClass('is-active');
      $section.addClass('is-active is-animated');

      $wrap1.addClass('is-active');
      $wrap2.addClass('is-active');

      $close.on('click', (e2) => {
        e2.preventDefault();

        $sections.removeClass('is-animated');
        setTimeout(() => {
          $sections.removeClass('is-active');
          $wrap1.removeClass('is-active');
          $wrap2.removeClass('is-active');
        }, 200);
      });
    });
  }
};
